var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"title":_vm.boardTitle,"mStyle":'width: 1024px;'}},[_c('BoardRead',{attrs:{"webpartParam":_vm.value,"isModal":true},on:{"articleLoaded":_vm.onArticleLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }